import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";

import { getDeliveryPartner } from "../services/adminApi";

import DeliveryProfileCard from "../components/delivery/DeliveryProfileCard";
import DeliveryStatsCard from "../components/delivery/DeliveryStatsCard";
import VehicleCard from "../components/delivery/VehicleCard";
import DocumentsCard from "../components/delivery/DocumentsCard";
import DeliveryHistoryCard from "../components/delivery/DeliveryHistoryCard";
import DeliveryActionButtons from "../components/delivery/DeliveryActionButtons";

import "./DeliveryDetails.css";

function DeliveryDetails() {

    const { id } = useParams();

    const navigate = useNavigate();

   const [partnerData, setPartnerData] = useState(null);

    const [loading, setLoading] = useState(true);

    const loadPartner = async () => {

        try {

            setLoading(true);

           const res = await getDeliveryPartner(id);

setPartnerData(res.data);

        } catch (error) {

            console.error(error);

        } finally {

            setLoading(false);

        }

    };

    useEffect(() => {

        loadPartner();

    }, [id]);

    if (loading) {

        return (

            <div className="delivery-details-loading">

                <Loader2
                    className="spin"
                    size={45}
                />

                <p>Loading Delivery Partner...</p>

            </div>

        );

    }

  if (!partnerData) {

        return (

            <div className="delivery-details-loading">

                Delivery Partner Not Found.

            </div>

        );

    }
    const { partner, statistics } = partnerData;

    return (

        <div className="delivery-details-page">

            <div className="details-header">

                <button
                    className="back-btn"
                    onClick={() => navigate(-1)}
                >

                    <ArrowLeft size={18} />

                    Back

                </button>

                <div>

                    <h1>

                        Delivery Partner Details

                    </h1>

                    <p>

                        View complete information about the delivery partner.

                    </p>

                </div>

            </div>

            <div className="details-grid">

                <DeliveryProfileCard
                    partner={partner}
                />

              <DeliveryStatsCard
    statistics={statistics}
/>

                <VehicleCard
                    partner={partner}
                />

                <DocumentsCard
                    partner={partner}
                />

                <DeliveryHistoryCard
                    partner={partner}
                />

            </div>

            <DeliveryActionButtons
                partner={partner}
                reload={loadPartner}
            />

        </div>

    );

}

export default DeliveryDetails;